import { useAuth0 } from "@auth0/auth0-react";
import { AuthorizationResources } from "@rw1/permissions";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { LoadingPage } from "./components/LoadingPage";
import { MainLayout } from "./components/MainLayout";
import { Unauthorized } from "./components/Unauthorized";
import { useCompanySettings, useCurrentUser } from "./hooks";
import { useCurrentUserRoles } from "./hooks/useCurrentUserRoles";

export const App: FC = () => {
  const { isLoading } = useAuth0();

  const { user } = useCurrentUser();

  const { userRoles, isLoading: isRolesLoading } = useCurrentUserRoles();

  const allowedRoles = new Set([AuthorizationResources.Global.Group.Administrator, AuthorizationResources.Global.Group.Company_Administrator]);

  const hasAccess = Boolean(userRoles?.some((role) => allowedRoles.has(role.roleId)));

  const { isFetched: isCompanySettingsFetched } = useCompanySettings({
    companyId: user?.companyId,
    enabled: !!user?.companyId,
  });

  if (
    isLoading ||
    isRolesLoading ||
    !isCompanySettingsFetched
  ) {
    return <LoadingPage />;
  }

  return (
    <Routes>
      <Route
        element={hasAccess ? <MainLayout /> : <Unauthorized />}
        path="/*"
      />
    </Routes>
  );
};
